<template>
  <div id="login">
    <el-button :loading="loggingIn" @click="authenticate('github')"
      >Login with Github</el-button
    >
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loggingIn: false
    };
  },
  methods: {
    authenticate(provider) {
      this.loggingIn = true;

      this.$auth
        .authenticate(provider)
        .then(() => {
          this.$router.push("profile");
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.loggingIn = false;
        });
    }
  }
};
</script>
